import { Plugin, PluginKey, TextSelection } from 'prosemirror-state'

import { Editor } from '@tiptap/core'
import { find } from 'linkifyjs'
import { MarkType } from 'prosemirror-model'

type PasteHandlerOptions = {
  editor: Editor
  type: MarkType
}

export function pasteHandler(options: PasteHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey('handlePasteLink'),
    props: {
      handlePaste: (view, _event, slice) => {
        const { state } = view
        const { selection } = state
        const { empty } = selection

        if (empty) {
          return false
        }

        let textContent = ''

        slice.content.forEach(node => {
          textContent += node.textContent
        })

        const link = find(textContent).find(
          item => item.isLink && item.value === textContent
        )

        if (!textContent || !link) {
          return false
        }

        options.editor.commands.setMark(options.type, {
          href: link.href,
        })

        return true
      },
      // Handle mobile keyboard clipboard insertion
      handleTextInput(view, from, to, text) {
        const { state, dispatch } = view
        const links = find(text).filter(item => item.isLink)

        if (links.length === 0) return false

        const tr = state.tr
        const fragment: any[] = []
        let lastIndex = 0

        links.forEach(link => {
          if (link.start > lastIndex) {
            fragment.push(state.schema.text(text.slice(lastIndex, link.start)))
          }
          fragment.push(
            state.schema.text(link.value, [
              options.type.create({ href: link.href }),
            ])
          )
          lastIndex = link.end
        })

        if (lastIndex < text.length) {
          fragment.push(state.schema.text(text.slice(lastIndex)))
        }

        // Replace with fragment directly instead of creating a paragraph
        tr.replaceWith(from, to, fragment)
        // Set cursor position to the end of the text
        tr.setSelection(TextSelection.create(tr.doc, from + text.length))
        dispatch(tr)

        return true
      },
    },
  })
}
